import { Component, Input } from '@angular/core';

@Component({
  selector: 'payarc-section-card',
  template: `
    <div class="pa-scard">
      <div class="pa-scard__head" *ngIf="heading">
        <div class="pa-scard__head-text"><h3>{{ heading }}</h3><p *ngIf="sub">{{ sub }}</p></div>
        <ng-content select="[scard-action]"></ng-content>
      </div>
      <div class="pa-scard__body" [class.pa-scard__body--flush]="flush"><ng-content></ng-content></div>
    </div>`,
  styleUrls: ['./payarc-section-card.component.css'],
  standalone: false
})
export class PayarcSectionCardComponent {
  @Input() heading = '';
  @Input() sub?: string;
  @Input() flush = false;
}
